import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: null,
  admin: null,
};

const adminsSlice = createSlice({
  name: "adminSlice",
  initialState,
  reducers: {
    login: (state, action) => {
      state.token = action.payload.token;
      state.admin = action.payload.admin;
    },

    logout: (state) => {
      state.token = null;
      state.admin = null;
    },
  },
});
export const { login, logout } = adminsSlice.actions;
export default adminsSlice.reducer
